import React,{useEffect} from 'react';
import Overlay from '../../FeatureComponents/Overlay'
import leftArrow from '../../../../assets/imgs/left-arrow.svg';
import logoutApi from '../../FeatureComponents/SessionTimeout/LogoutApi';


const LiveAgentScreen = ({liveAgentData,toggleLiveAgentScreen, showLiveAgentScreen,isChatBodyVisible,startSessionTimeout}) => {    useEffect(()=>{
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        }
    },[]);

    function handleMessage(e){
        if (e.data === "keepAlive" || e.message === "keepAlive"){
            callKeepAliveApi('keep-alive')
        }else if(e.data === 'exitLiveChat'||e.message  === 'exitLiveChat') {
            toggleLiveAgentScreen(true);
        }
    }
    function callKeepAliveApi(type){
        logoutApi(type).then(function(msg){
            startSessionTimeout();
            // console.log('keep-alive called');
        });
    }
    function handleLiveChatExit() {
        //function call
        try{
            document.getElementById("lv-ag-iframe").contentWindow.postMessage("LiveChatExit","*");
            toggleLiveAgentScreen(true);
        }catch(e){
            toggleLiveAgentScreen(true);
        }
        
    }

    function handleLiveAgent(ev){
       
        ev.target.contentWindow.postMessage(JSON.stringify({showLiveAgentScreen,liveAgentData}), '*');
    }

    return (
       <Overlay style={{flexDirection: 'column',height: 'calc(100% - 83px)',display: isChatBodyVisible ? 'flex' : 'none'}} id="lv-ag-iframe-overlay">
            {/* <div className="live-agent-iframe-head">
                <img onClick={() => handleLiveChatExit()} src={leftArrow} alt="" />
                <span onClick={() => handleLiveChatExit()}>
                    Exit Live Chat
                </span>
            </div> */}
            <iframe id="lv-ag-iframe" onLoad={handleLiveAgent} src={`${window['SF_BASE_URL']}/CPChatRequest.html`} frameBorder="0"></iframe>
        </Overlay>
    )
}

export default LiveAgentScreen;